import React from 'react';
import { Header, Divider, List, Segment, Table } from 'semantic-ui-react';
import config from '../../config';

export function WelcomeText(props) {
  return (
    <React.Fragment>
      <Header as='h3'>{`Ohjeita`}</Header>
      <p>Alla näet kartta-aineistot, joita pystyt päivittämään automatisoidun prosessimme avulla.</p>
      <p>Tason julkaiseminen tapahtuu seuraavasti:</p>
      <List ordered>
        <List.Item>
          <List.Header>Lataa tiedostot ftp-yhteydellä tai selaimen kautta.</List.Header>
          <List.Description>Erittäin suuret tiedostot kannattaa ladata ftp-yhteyden kautta. Olethan tarkkana ladatessasi uusia tiedostoja palveluun, jotta tiedostojen nimet vastaavat alla olevia määrittelyjä.</List.Description>
        </List.Item>
        <List.Item>
          <List.Header>Kun tiedostot ovat levyllä ja päivitettävä taso näkyy vihreänä, käynnistä prosessi painikkeesta.</List.Header>
        <List.Description>Tason julkaisemiseen kuluva aika riippuu paljon tiedostojen tyypistä, koosta sekä niille tehtävistä prosesseista.
          Prosessiajo ei keskeydy, vaikka poistuisit sivustolta.
        </List.Description>
        </List.Item>
        <List.Item>
          <List.Header>Prosessoinnin päätyttyä esikatsele taso "Julkaise"-painikkeesta.</List.Header>
          <List.Description>Jos aineistossa näkyy virheitä, päivitä korjatut tiedostot ftp-levylle ja aja prosessi uudelleen.</List.Description>
        </List.Item>
        <List.Item>
          <List.Header>Vahvista tason julkaisu ja paina "Julkaise taso".</List.Header>
          <List.Description>Julkaistu taso päivittyy kaikkiin karttapalveluihin.</List.Description>
        </List.Item>
      </List>
      <p>Muistathan, ettei automatisoidulla prosessilla ole vielä mahdollista ladata kokonaan uusia tasoja palveluun,
      vaan automaatio on tarkoitettu olemassa olevien tasojen päivitykseen.</p>
      <p>Jos tarvitset apua palvelun käytössä, ota yhteyttä sähköpostitukeen: <a href="mailto:support.lbs.fi@cgi.com">support.lbs.fi@cgi.com</a></p>
      <Divider />
    </React.Fragment>
  )
}

export function LoginInfo(props) {
  return (
    <React.Fragment>
      <Header as='h3'>{`Hei ${props.user.firstName} ${props.user.lastName}`}</Header>
      <p>{`Kuulunut organisaatioon ${props.user.organizationName ? props.user.organizationName : '<tyhjä>'} ja
      ${props.user.is_staff ? "olet tämän järjestelmän henkilökuntaa." :
      (props.user.is_organization_staff ? "olet pääkäyttäjä organisaatiossasi." : "olet tavallinen käyttäjä.")}`}</p>
      <p>{`Sähköpostisi on ${props.user.email ? props.user.email : '<tyhja>'}.`}</p>
      <Divider />
    </React.Fragment>
  )

}

export function MapServices({ mapservices, workspace }) {
  return (
    <React.Fragment>
      <Header as='h3'>Karttapalvelut</Header>
      {mapservices.length > 0 &&
        <React.Fragment>
          <Table>
            <Table.Body>
              {mapservices.map((s, i) => (
                <Table.Row key={i}>
                  <Table.Cell>
                    {s.name}
                  </Table.Cell>
                  <Table.Cell>
                    <a href={s.url} target="_blank">{s.url}</a>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </React.Fragment>
      }
      <p>Voit {mapservices.length > 0 && "lisäksi "}katsella suojaamattomia karttatasoja paikkatieto-ohjelman (esim. QGIS, MapInfo, ArcGIS) avulla.
        Lisää ohjelmaan uusi WMS-taso käyttäen seuraavaa osoitetta:</p>
      <Segment>{config.geoserverUrl}/geoserver/{workspace}/wms?</Segment>
      <p>Tarkista tason URL-nimi siirtämällä hiiri tason nimen päälle. Esikatseltavana olevan tason nimi on sama kuin julkaistulla tasolla, 
        mutta perässä on "_preview" -takaliite.</p>
      <Divider />
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/containers/main/InfoTexts.js